import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useHighFrequencyRefreshQuery } from '../../../queryDefaults/baseQueries/useHighFrequencyRefreshQuery';
import { ITask, Task } from '../Tasks.ts';
import { TasksApi } from '../../../apis/TasksApi/TasksApi.ts';
import { patientStore } from '../../../Store/Store.ts';

export function useGetTasksByPatient() {
    const patientId = patientStore.patientId;
    return useHighFrequencyRefreshQuery({
        queryKey: [QueryKeys.tasks, patientId],
        queryFn: async () => {
            const result: ITask[] = await TasksApi.getTasksByPatient(patientId!);
            return result ? result.map((x: ITask) => new Task(x)) : [];
        },
        enabled: !!patientId,
    });
}
